import './Skeleton.css';

export interface SkeletonProps {
  /** CSS width, default 100 %. */
  width?: string | number;
  /** CSS height, default 1em. */
  height?: string | number;
  /** Rounded pill for text, block for tiles/images. */
  shape?: 'text' | 'block' | 'circle';
  className?: string;
}

/** Loading placeholder. Never spinners in tables; skeleton rows instead. */
export function Skeleton({ width = '100%', height = '1em', shape = 'text', className }: SkeletonProps) {
  return <span className={['skeleton', `skeleton-${shape}`, className ?? ''].filter(Boolean).join(' ')} style={{ width, height }} aria-hidden="true" />;
}

/** A list of skeleton rows (default 5) with a faint thumbnail and two lines. */
export function SkeletonRows({ rows = 5, thumbnail = false }: { rows?: number; thumbnail?: boolean }) {
  return (
    <div className="skeleton-rows" aria-busy="true" aria-label="Laddar">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="skeleton-row">
          {thumbnail ? <Skeleton shape="block" width={40} height={40} /> : null}
          <div className="skeleton-lines">
            <Skeleton width={`${55 + ((i * 17) % 30)}%`} />
            <Skeleton width={`${30 + ((i * 11) % 25)}%`} height="0.75em" />
          </div>
          <Skeleton width={72} />
        </div>
      ))}
    </div>
  );
}

/** Route-level fallback: a title, a paragraph and rows. */
export function PageSkeleton() {
  return (
    <div className="page-skeleton" aria-busy="true" aria-label="Laddar">
      <Skeleton width="40%" height="1.6em" />
      <Skeleton width="70%" />
      <SkeletonRows rows={4} />
    </div>
  );
}
